<template>
    <div class="home-view">
      <Topbar />
      
      <div class="container-fluid" style="padding-top: 90px">
        

        <div class="card w-100">
            <div class="card-header bg-info text-white">
                <h4 class="m-0">
                    EMPRESAS FATURAMENTO
                    <em class="fa fa-building ml-2 mr-4"></em>
                    <div v-show="carregando" class="spinner-grow" role="status">
                <span class="sr-only">Loading...</span>
            </div>
                </h4>
            </div>

            <div class="card-body">

                <div class="alert alert-danger" v-if="this.error">
                    {{ error }}
                </div>

                <div class="card">
                    <div class="card-body">
                        <div class="row text-left">
                            <div class="col-md-6">
                                <label for="empresa">NOME DA EMPRESA</label>
                                <input type="text" autocomplete="off" id="empresa" class="form-control">
                            </div>
                            <div class="col-md-2 pt-2">
                                <br>
                                <button class="btn btn-primary" @click="confirmSalve()">
                                    Cadastrar
                                    <em class="fa fa-save ml-2"></em>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-lg-12 table-responsive">
                        <table class="table table-striped table-bordered table-sm">
                            <thead>
                                <th>#</th>
                                <TableHeader db="name" label="Nome" />
                                <TableHeader db="edit" label="Alterar" />
                            </thead>
                            <tbody>
                                <tr v-for="(item) in combos.idempresasfat" :key="item.id">
                                    <td>
                                        {{ item.id }}
                                    </td>
                                    <td>
                                        {{ item.name }}
                                    </td>
                                    <td>
                                        <button class="btn btn-sm btn-primary" @click="confirmUpdate(item.id, item.name)">
                                            <em class="fa fa-edit"></em>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <TableFooter />
            </div>
        </div>
      </div>    
      <LogoutModal/>
      <Sidebar/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import Topbar from '@/components/Topbar.vue'
  import Sidebar from '@/components/Sidebar.vue'
  import LogoutModal from '@/components/LogoutModal.vue'
  import ViewMixin from './ViewMixin'
  import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException, ValidationException, PermissaoException, ClientErrorException } from '../services/exceptions'
  import api from '../services/api'
  import TableHeader from "@/components/TableHeader.vue";
  import TableFooter from "../components/TableFooter.vue";
  import $ from "jquery";
  import Swal from 'sweetalert2'

  export default {
    name: 'Home',
    mixins: [
      ViewMixin
    ],
    components: {
      Topbar,
      Sidebar,
      LogoutModal,
      TableHeader,
      TableFooter
    },

    data: function () {
        return {
            baseUrl: "contratos",
            combos: {
                idcliente: [],
            },
            error: null,
        }
    },
  
    async mounted() {
      try {
        await this.validarToken();
        await this.getCombo();
      } catch (e) {
        if (e instanceof TokenInvalidoException) {
          this.handleTokenInvalidoException();
        } else if (e instanceof ServerErrorException) {
          alert(e.message);
        } else {
          alert(DEFAULT_ERROR_MESSAGE);
        }      
      }
    },
  
    methods: {
      async validarToken() {
        this.carregando = true;
  
        await api.get("/validar-token");
  
        this.carregando = false;
      },
  
      async getCombo() {
            this.carregando = true;

            try {

                let response = await api.get(`/${this.baseUrl}/combosToSave`);
                let data = response.data;

                this.combos = data;
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },

        async confirmSalve() {

            if ($("#empresa").val() === null || $("#empresa").val() === "") {
                this.error = "Informe o nome da empresa!";
                $("#empresa").focus();
                this.carregando = false;
                return;
            }

            Swal.fire({
                text: 'Deseja cadastrar a empresa: ' + $("#empresa").val(),
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
                preConfirm: () => {
                    this.salvar();
                }
            });
        },

        async salvar() {
            this.carregando = true;

            try {

                let response = await api.post(`/${this.baseUrl}/empresa/cadastrar`, {
                    nome: $("#empresa").val()
                });

                this.error = null;

                if (JSON.stringify(response.data).includes("Sucesso")) {
                    this.getCombo();
                    $("#empresa").val("");
                }
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },

        async confirmUpdate(id, nome) {


            Swal.fire({
                html: `<label for="nomeEmpresaModal">Atualização do nome da empresa "${nome}"</label>
                <input class="form-control" autocomplete="off" id="nomeEmpresaModal" value="${nome}" placeholder="Nome da Empresa:">`,
                showCancelButton: true,
                confirmButtonText: "Alterar",
                cancelButtonText: "Cancelar",
                preConfirm: () => {
                    let novoNome = $("#nomeEmpresaModal").val();

                    if ($("#nomeEmpresaModal").val() === null || $("#nomeEmpresaModal").val() === "") {
                        this.confirmUpdate(id, nome);
                        return;
                    }
                    
                    this.update(id, novoNome);
                }
            });

            setTimeout(() => {
                $("#nomeEmpresaModal").focus();
                $("#nomeEmpresaModal").select();
            }, 250);
        },

        async update(id, nome) {
            this.carregando = true;

            try {

                let response = await api.put(`/${this.baseUrl}/empresa/atualizar`, {
                    nome: nome,
                    id: id
                });

                this.error = null;

                if (JSON.stringify(response.data).includes("Sucesso")) {
                    this.getCombo();
                    $("#empresa").val("");
                }
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
            },
    }
  }
  </script>
  
  <style scoped lang="scss">    
  
    .home-view {
      height: 100%;
    }
  
    .container-img {
      display: flex;
      justify-content: center;
      align-self: center;
  
      background-color: rgb(233, 233, 233) !important;
      height: 100%;
    }
  </style>
  